import { createAction, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { AccountRelationshipRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AccountRelationshipsState {
    [key: string]: AccountRelationshipRecord;
}

const initialState: AccountRelationshipsState = {};

const initialLoad = createAction<{ accountrelationships: AccountRelationshipsState }>('InitialLoad');
const accountRelationshipRecord = createAction<AccountRelationshipRecord>(CoreMsgTypes.AccountRelationshipRecord);

const accountRelationshipsSlice = createSlice({
    name: 'accountrelationships',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(accountRelationshipRecord, (state, action) => {
            state[action.payload.AcctRelationshipId] = action.payload;
        })
            .addMatcher(isAnyOf(initialLoad),
                (state, action) => {
                    Object.assign(state, action.payload.accountrelationships);
                });
    }
});

export default accountRelationshipsSlice.reducer;